import { SUPPORTED_LANGUAGES } from './constants';

/**
 * Get language from URL search params for custom routes
 * Custom routes use ?lang= parameter instead of path-based language detection
 */
export const getCustomLanguageFromURL = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang')?.toLowerCase();

  if (langParam) {
    const supportedCodes = SUPPORTED_LANGUAGES.map((lang) => lang.code);
    if (supportedCodes.includes(langParam)) {
      return langParam;
    }
  }

  return 'en'; // Default to English
};

/**
 * Update URL with language parameter while preserving other query params
 */
export const updateCustomLanguageInURL = (language: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', language);
  window.history.replaceState({}, '', url.toString());
};

/**
 * Get language configuration for a given language code
 */
export const getLanguageConfig = (languageCode: string) => {
  return (
    SUPPORTED_LANGUAGES.find((lang) => lang.code === languageCode) ||
    SUPPORTED_LANGUAGES[0]
  );
};
